import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";
// PASTE YOUR CONFIG FROM FIREBASE CONSOLE HERE
const firebaseConfig = {
    apiKey: "AIzaSyCWEm4euc7-iRx99AdOiXTaU-GMKjwhgVM",
    authDomain: "websitefitness-69f6b.firebaseapp.com",
    projectId: "websitefitness-69f6b",
    storageBucket: "websitefitness-69f6b.firebasestorage.app",
    messagingSenderId: "347547706064",
    appId: "1:347547706064:web:a0a8ac7ae335839273b4d5",
    measurementId: "G-XGBQ9RSHS5"
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);